import { render, staticRenderFns } from "./DashboardClientTable.vue?vue&type=template&id=818137ca&scoped=true&"
import script from "./DashboardClientTable.vue?vue&type=script&lang=ts&"
export * from "./DashboardClientTable.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardClientTable.vue?vue&type=style&index=0&id=818137ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818137ca",
  null
  
)

export default component.exports